import React from 'react'
import { NavLink } from 'react-router-dom'
import { Navbar } from 'components/navbar'
import { Footer } from 'components/footer'
import { cn } from 'lib/utils'

const TABS = [
  { to: '/partners', label: 'Partners', end: true },
  { to: '/partners/applications', label: 'Applications', end: false },
  { to: '/partners/payouts', label: 'Payouts', end: false },
  { to: '/partners/config', label: 'Program config', end: false },
]

type Props = {
  title: string
  actions?: React.ReactNode
  children: React.ReactNode
}

const PartnersLayout: React.FC<Props> = ({ title, actions, children }) => (
  <div className="flex flex-col min-h-screen bg-neutral-white font-sans text-neutral-900">
    <Navbar />
    <main className="flex-1 mx-auto w-full max-w-6xl px-4 md:px-8 py-6">
      <div className="flex items-center gap-6 border-b border-neutral-200 mb-6">
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            className={({ isActive }) =>
              cn(
                'py-3 text-sm font-semibold border-b-2 -mb-px',
                isActive
                  ? 'text-brand-primary border-brand-primary'
                  : 'text-neutral-600 border-transparent hover:text-brand-primary',
              )
            }
          >
            {t.label}
          </NavLink>
        ))}
      </div>
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-semibold">{title}</h1>
        {actions}
      </div>
      {children}
    </main>
    <Footer />
  </div>
)

export default PartnersLayout
